@if (currentQuestion) {
<div class="m-1 md:m-2  h-full flex flex-col justify-between">
  <div class="flex flex-col grow">
    @if(currentQuestion.HelpText != undefined && currentQuestion.QuestionType != undefined){
       <div class="flex" [ngClass]="{'justify-between':currentQuestion.HelpText.length > 0}">

      <div class="flex flex-col">
        @if (currentQuestion.QuestionType.ID == 6) {
          <h2 class="font-bold">
            {{ currentQuestion.QuestionHeader }}
          </h2>
        }
        @if (currentQuestion.QuestionType.ID != 6) {
          <h3 class="text-xl">
            {{ currentQuestion.QuestionHeader }}
          </h3>
        }
        <p>{{ currentQuestion.QuestionBody }}</p>
      </div>
      @if (currentQuestion.HelpText.length > 0) {
        <div class="ml-1">
          <app-help-guidance [text]="currentQuestion.HelpText"></app-help-guidance>
        </div>
      }
    </div>
    }
    @if(currentQuestion.QuestionType!=undefined){
    <div>
      @switch ( currentQuestion.QuestionType.ID) {
        @case (1) {
          <div>
            @if (!currentQuestion.NASelected) {
              <app-radio-button [(currentQuestion)]="currentQuestion"
              (currentQuestionChange)="updateLocalData()"></app-radio-button>
            }
            <div class="flex justify-between align-middle">
              <div class="flex mt-4 gap-4">
                <button class="btn-primary relative" (click)="showPhoto()"><span
                class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">photo_camera</span>
                @if (this.currentQuestion.CompletionInfo.Photos.length > 0) {
                  <span class="badge"
                  >{{this.currentQuestion.CompletionInfo.Photos.length}}</span>
                }</button>
                <button class="btn-primary relative" (click)="showAttachment()"><span
                class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">attach_file</span>
                @if (this.currentQuestion.CompletionInfo.Attachments.length > 0) {
                  <span class="badge"
                  >{{this.currentQuestion.CompletionInfo.Attachments.length}}</span>
                }</button>
              </div>
              @if (currentQuestion.AllowNA) {
                <div class="mt-4 flex items-center ml-3 md:ml-0">
                  <label for="" class="mr-2">Not Applicable</label><app-toggle-switch [(checked)]="currentQuestion.NASelected"
                (checkedChange)="updateLocalData()"></app-toggle-switch>
              </div>
            }
          </div>
          <app-question-photo [currentQuestion]="currentQuestion" [showWebcam]="showWebcam"
          (currentQuestionChange)="updateLocalData()"></app-question-photo>
          <app-question-attachment [showAttachments]="showAttachments" [currentQuestion]="currentQuestion"
          (currentQuestionChange)="updateLocalData()"></app-question-attachment>
        </div>
      }
      @case (2) {
        <div>
          @if (!currentQuestion.NASelected) {
            <app-drop-down [(currentQuestion)]="currentQuestion"
            (currentQuestionChange)="updateLocalData()"></app-drop-down>
          }
          <div class="flex justify-between align-middle">
            <div class="flex mt-4 gap-4">
              <button class="btn-primary relative" (click)="showPhoto()"><span
              class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">photo_camera</span>
              @if (this.currentQuestion.CompletionInfo.Photos.length > 0) {
                <span class="badge"
                >{{this.currentQuestion.CompletionInfo.Photos.length}}</span>
              }</button>
              <button class="btn-primary relative" (click)="showAttachment()"><span
              class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">attach_file</span>
              @if (this.currentQuestion.CompletionInfo.Attachments.length > 0) {
                <span class="badge"
                >{{this.currentQuestion.CompletionInfo.Attachments.length}}</span>
              }</button>
            </div>
            @if (currentQuestion.AllowNA) {
              <div class="mt-4 flex items-center">
                <label for="" class="mr-2">Not Applicable</label><app-toggle-switch [(checked)]="currentQuestion.NASelected"
              (checkedChange)="updateLocalData()"></app-toggle-switch>
            </div>
          }
        </div>
        <app-question-photo [currentQuestion]="currentQuestion" [showWebcam]="showWebcam"
        (currentQuestionChange)="updateLocalData()"></app-question-photo>
        <app-question-attachment [showAttachments]="showAttachments" [currentQuestion]="currentQuestion"
        (currentQuestionChange)="updateLocalData()"></app-question-attachment>
      </div>
    }
    @case (3) {
      <div>
        @if (!currentQuestion.NASelected) {
          <app-multi-select [(currentQuestion)]="currentQuestion"
          (currentQuestionChange)="updateLocalData()"></app-multi-select>
        }
        <div class="flex justify-between align-middle">
          <div class="flex mt-4 gap-4">
            <button class="btn-primary relative" (click)="showPhoto()"><span
            class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">photo_camera</span>
            @if (this.currentQuestion.CompletionInfo.Photos.length > 0) {
              <span class="badge"
              >{{this.currentQuestion.CompletionInfo.Photos.length}}</span>
            }</button>
            <button class="btn-primary relative" (click)="showAttachment()"><span
            class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">attach_file</span>
            @if (this.currentQuestion.CompletionInfo.Attachments.length > 0) {
              <span class="badge"
              >{{this.currentQuestion.CompletionInfo.Attachments.length}}</span>
            }</button>
          </div>
          @if (currentQuestion.AllowNA) {
            <div class="mt-4 flex items-center">
              <label for="" class="mr-2">Not Applicable</label><app-toggle-switch [(checked)]="currentQuestion.NASelected"
            (checkedChange)="updateLocalData()"></app-toggle-switch>
          </div>
        }
      </div>
      <app-question-photo [currentQuestion]="currentQuestion" [showWebcam]="showWebcam"
      (currentQuestionChange)="updateLocalData()"></app-question-photo>
      <app-question-attachment [showAttachments]="showAttachments" [currentQuestion]="currentQuestion"
      (currentQuestionChange)="updateLocalData()"></app-question-attachment>
    </div>
  }
  @case (4) {
    <div>
      @if (!currentQuestion.NASelected) {
        <app-text-entry [(currentQuestion)]="currentQuestion"
        (currentQuestionChange)="updateLocalData()"></app-text-entry>
      }
      <div class="flex justify-between align-middle">
        <div class="flex mt-4 gap-4">
          <button class="btn-primary relative" (click)="showPhoto()"><span
          class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">photo_camera</span>
          @if (this.currentQuestion.CompletionInfo.Photos.length > 0) {
            <span class="badge"
            >{{this.currentQuestion.CompletionInfo.Photos.length}}</span>
          }</button>
          <button class="btn-primary relative" (click)="showAttachment()"><span
          class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">attach_file</span>
          @if (this.currentQuestion.CompletionInfo.Attachments.length > 0) {
            <span class="badge"
            >{{this.currentQuestion.CompletionInfo.Attachments.length}}</span>
          }</button>
        </div>
        @if (currentQuestion.AllowNA) {
          <div class="mt-4 flex items-center">
            <label for="" class="mr-2">Not Applicable</label><app-toggle-switch [(checked)]="currentQuestion.NASelected"
          (checkedChange)="updateLocalData()"></app-toggle-switch>
        </div>
      }
    </div>
    <app-question-photo [currentQuestion]="currentQuestion" [showWebcam]="showWebcam"
    (currentQuestionChange)="updateLocalData()"></app-question-photo>
    <app-question-attachment [showAttachments]="showAttachments" [currentQuestion]="currentQuestion"
    (currentQuestionChange)="updateLocalData()"></app-question-attachment>
  </div>
}
@case (5) {
  <div>
    @if (!currentQuestion.NASelected) {
      <app-narrative [(currentQuestion)]="currentQuestion"
      (currentQuestionChange)="updateLocalData()"></app-narrative>
    }
    <div class="flex justify-between align-middle">
      <div class="flex mt-4 gap-4">
        <button class="btn-primary relative" (click)="showPhoto()"><span
        class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">photo_camera</span>
        @if (this.currentQuestion.CompletionInfo.Photos.length > 0) {
          <span class="badge"
          >{{this.currentQuestion.CompletionInfo.Photos.length}}</span>
        }</button>
        <button class="btn-primary relative" (click)="showAttachment()"><span
        class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">attach_file</span>
        @if (this.currentQuestion.CompletionInfo.Attachments.length > 0) {
          <span class="badge"
          >{{this.currentQuestion.CompletionInfo.Attachments.length}}</span>
        }</button>
      </div>
      @if (currentQuestion.AllowNA) {
        <div class="mt-4 flex items-center">
          <label for="" class="mr-2">Not Applicable</label><app-toggle-switch [(checked)]="currentQuestion.NASelected"
        (checkedChange)="updateLocalData()"></app-toggle-switch>
      </div>
    }
  </div>
  <app-question-photo [currentQuestion]="currentQuestion" [showWebcam]="showWebcam"
  (currentQuestionChange)="updateLocalData()"></app-question-photo>
  <app-question-attachment [showAttachments]="showAttachments" [currentQuestion]="currentQuestion"
  (currentQuestionChange)="updateLocalData()"></app-question-attachment>
</div>
}

@case (8) {
  <div>
    @if (showCanvas) {
      <signature-pad class="" [options]="canvasOptions"
      (onEndEvent)="saveCanvas()"></signature-pad>
    }
    @if (!showCanvas) {
      <img [src]="currentQuestion.CompletionInfo.Answer"
        class="w-[250px] h-[150px] md:w-[500px] md:h-[300px]" />
    }
    <div class="mt-4">
      @if (showCanvas) {
        <button class="btn-primary w-[250px] md:w-[500px]" (click)="clearCanvas()">
          Clear
        </button>
      }
      @if (!showCanvas) {
        <button class="btn-primary w-[500px]" (click)="clearCanvas()">
          Reset
        </button>
      }
    </div>
  </div>
}
@case (9) {
  <div class="mt-4">
    @if (!currentQuestion.NASelected) {
      <app-date-only [(currentQuestion)]="currentQuestion"
      (currentQuestionChange)="updateLocalData()"></app-date-only>
    }
  </div>
}
@case (10) {
  <div class="flex mt-4">
    @if (!currentQuestion.NASelected) {
      <app-date-time [(currentQuestion)]="currentQuestion"
      (currentQuestionChange)="updateLocalData()"></app-date-time>
    }
  </div>
}
@case (11) {
  <div>
    @if (!currentQuestion.NASelected) {
      <app-narrative [(currentQuestion)]="currentQuestion"
      (currentQuestionChange)="updateLocalData()"></app-narrative>
    }
    <div class="flex justify-between align-middle">
      <div class="flex mt-4 gap-4">
        <button class="btn-primary relative" (click)="showPhoto()"><span
        class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">photo_camera</span>
        @if (this.currentQuestion.CompletionInfo.Photos.length > 0) {
          <span class="badge"
          >{{this.currentQuestion.CompletionInfo.Photos.length}}</span>
        }</button>
        <button class="btn-primary relative" (click)="showAttachment()"><span
        class="material-symbols-outlined text-3xl mr-1 align-bottom text-standardwhite self-center">attach_file</span>
        @if (this.currentQuestion.CompletionInfo.Attachments.length > 0) {
          <span class="badge"
          >{{this.currentQuestion.CompletionInfo.Attachments.length}}</span>
        }</button>
      </div>
      @if (currentQuestion.AllowNA) {
        <div class="mt-4 flex items-center">
          <label for="" class="mr-2">Not Applicable</label><app-toggle-switch [(checked)]="currentQuestion.NASelected"
        (checkedChange)="updateLocalData()"></app-toggle-switch>
      </div>
    }
  </div>
  <app-question-photo [currentQuestion]="currentQuestion" [showWebcam]="showWebcam"
  (currentQuestionChange)="updateLocalData()"></app-question-photo>
  <app-question-attachment [showAttachments]="showAttachments" [currentQuestion]="currentQuestion"
  (currentQuestionChange)="updateLocalData()"></app-question-attachment>
</div>
}
@case (12) {
  <div>
    <p>GPS</p>
  </div>
}
}
</div>
}
@if (showAction()) {
  <h5 class="text-green-700 mt-5">Non-Compliance</h5>
}
@if (showAction()) {
  <app-question-action [actionUsers]="actionUsers" [(currentQuestion)]="currentQuestion"
  (currentQuestionChange)="updateLocalData()"></app-question-action>
}
</div>
<div>
  @if (currentQuestion.AllowComments) {
    <div class="my-4">
      <h5 class="text-green-700">Notes and Observations</h5>
      <textarea rows="5" class="text-box mt-1" placeholder="" [(ngModel)]="currentQuestion.CompletionInfo.Comments"
      (keyup)="updateLocalData()"></textarea>
    </div>
  }
</div>
</div>
}
